import { inject as service } from '@ember/service';
import { resolve } from 'rsvp';
import Base from 'ember-simple-auth/authenticators/base';
import { getAccessCookie } from 'cio/utils/auth-cookies';
import AuthService from 'cio/services/auth';

// authenticator used to initialize session after obtaining user access token using non-standard mechanism, i.e. other than using login form
// real-life example: creating new user session directly after sign-up, where server response contains user access token

export default class AccessTokenAuthenticator extends Base {
  @service auth!: AuthService;

  restore() {
    return resolve({
      accessToken: getAccessCookie() as string,
    });
  }

  authenticate({ accessToken, sessionExpiresAt }: { accessToken: string; sessionExpiresAt: number }) {
    this.auth.setAccessCookiesAndExpiration(accessToken, sessionExpiresAt);
    return resolve({
      accessToken,
    });
  }
}
